const DATA_ID = 'data-id';

export default function addScriptToDOM(url, attributes = {}, id) {
    return new Promise((resolve, reject) => {
        // check if a script already exists with this id, if provided
        let isScriptLoaded;
        if (id) {
            const existingScript = document.querySelector(`script[${DATA_ID}="${id}"]`);
            isScriptLoaded = !!existingScript;
        }

        if (!isScriptLoaded) {
            const script = document.createElement('script');

            script.src = url;

            // Set all given attributes
            Object.keys(attributes).forEach((key) => {
                script.setAttribute(key, attributes[key]);
            });

            if (id) {
                script.setAttribute(DATA_ID, id);
            }

            // Set promise callbacks
            script.onload = resolve;
            script.onerror = reject;

            document.head.appendChild(script);
        }
    });
}
